"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1570],{

/***/ 62992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fab",
    "data-icon": "github",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 512",
    style: {
      fill: "currentColor"
    }
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgGithub);

/***/ }),

/***/ 96724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-35.2 -41.333 305.067 248"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M229.763 25.817c-2.699-10.162-10.65-18.165-20.747-20.881C190.716 0 117.333 0 117.333 0S43.951 0 25.651 4.936C15.554 7.652 7.602 15.655 4.904 25.817 0 44.237 0 82.667 0 82.667s0 38.43 4.904 56.85c2.698 10.162 10.65 18.164 20.747 20.881 18.3 4.935 91.682 4.935 91.682 4.935s73.383 0 91.683-4.935c10.097-2.717 18.048-10.72 20.747-20.88 4.904-18.422 4.904-56.851 4.904-56.851s0-38.43-4.904-56.85",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m93.333 117.558 61.334-34.89-61.334-34.893z",
    fill: "#fff"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgYoutube);

/***/ }),

/***/ 29422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ add; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77349);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11640);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);






/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(dirtyDate, duration) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  if (!duration || typeof duration !== 'object') return new Date(NaN);
  var years = duration.years ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.years) : 0;
  var months = duration.months ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.weeks) : 0;
  var days = duration.days ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.days) : 0;
  var hours = duration.hours ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.seconds) : 0; // Add years and months

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate);
  var dateWithMonths = months || years ? (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, months + years * 12) : date; // Add weeks and days

  var dateWithDays = days || weeks ? (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds

  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1000;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}

/***/ }),

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 11640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 61570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ JobPostDetail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/formatters/timeSinceFormatter.ts
var timeSinceFormatter = __webpack_require__(65997);
// EXTERNAL MODULE: ./services/googleAnalytics/index.ts
var googleAnalytics = __webpack_require__(4231);
// EXTERNAL MODULE: ./services/mixpanel/index.ts
var mixpanel = __webpack_require__(81479);
// EXTERNAL MODULE: ./utils/classNames.ts
var classNames = __webpack_require__(43153);
// EXTERNAL MODULE: ./utils/redis/analytics/AnalyticsEvent.ts
var AnalyticsEvent = __webpack_require__(35571);
;// CONCATENATED MODULE: ./components/JobPost/fields/Apply.tsx






const Apply = (param)=>/*#__PURE__*/ {
    let { id , applyUrl , cN  } = param;
    return (0,jsx_runtime.jsx)("a", {
        className: (0,classNames/* classNames */.A)("px-4 py-4 bg-black border border-black text-white font-medium rounded-md hover:bg-transparent hover:text-black", cN),
        href: applyUrl,
        rel: "nofollow noopener noreferrer",
        target: "_blank",
        onClick: (e)=>{
            // Google analytics: Record job post apply.
            (0,googleAnalytics/* gtagEvent */.o)({
                name: "add_to_cart",
                payload: {
                    items: [
                        {
                            id
                        }
                    ]
                }
            });
            // Mixpanel: Record job post apply.
            (0,mixpanel/* mixpanelEvent */.f)({
                name: AnalyticsEvent/* AnalyticsEvent.JOB_POST_APPLY */.s.JOB_POST_APPLY,
                payload: {
                    id
                }
            });
            // Internal analytics: Record job post apply.
            fetch("/api/analytics/collect", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    event: AnalyticsEvent/* AnalyticsEvent.JOB_POST_APPLY */.s.JOB_POST_APPLY,
                    ids: [
                        id
                    ]
                })
            });
        },
        children: "Apply"
    });
};

// EXTERNAL MODULE: ./node_modules/.prisma/client/index-browser.js
var index_browser = __webpack_require__(22804);
// EXTERNAL MODULE: ./public/social-icons/twitter.svg
var twitter = __webpack_require__(66871);
// EXTERNAL MODULE: ./public/social-icons/linkedin.svg
var linkedin = __webpack_require__(43441);
// EXTERNAL MODULE: ./public/social-icons/github.svg
var github = __webpack_require__(62992);
// EXTERNAL MODULE: ./public/social-icons/instagram.svg
var instagram = __webpack_require__(57620);
// EXTERNAL MODULE: ./public/social-icons/youtube.svg
var youtube = __webpack_require__(96724);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/enumToLabel/organisationSizeToLabel.ts
var organisationSizeToLabel = __webpack_require__(54840);
;// CONCATENATED MODULE: ./components/JobPost/blocks/OrganisationBlock.tsx










const OrganisationBlock = (param)=>{
    let { organisation  } = param;
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/company/".concat(organisation === null || organisation === void 0 ? void 0 : organisation.slug),
                children: (organisation === null || organisation === void 0 ? void 0 : organisation.favicon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "rounded",
                        width: 48,
                        height: 48,
                        src: "".concat("https://xxshqbqasrbviwgjwzwp.supabase.co", "/storage/v1/object/public/public").concat(organisation === null || organisation === void 0 ? void 0 : organisation.favicon),
                        alt: "".concat((organisation === null || organisation === void 0 ? void 0 : organisation.name) || "", " logo")
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center w-12 h-12 rounded bg-gray-100 ",
                    children: organisation === null || organisation === void 0 ? void 0 : (ref = organisation.name) === null || ref === void 0 ? void 0 : ref[0]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/company/".concat(organisation === null || organisation === void 0 ? void 0 : organisation.slug),
                        className: "inline text-blue-600 font-bold",
                        children: organisation === null || organisation === void 0 ? void 0 : organisation.name
                    }),
                    (organisation === null || organisation === void 0 ? void 0 : organisation.size) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2 px-1 py-1 text-gray-600 bg-gray-100 rounded-sm text-xs font-medium ",
                        children: organisationSizeToLabel/* organisationSizeToLabel */.P[organisation === null || organisation === void 0 ? void 0 : organisation.size]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: organisation === null || organisation === void 0 ? void 0 : organisation.about
            }),
            ((organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl) || (organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl) || (organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row mt-2 space-x-4",
                children: [
                    (organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: organisation === null || organisation === void 0 ? void 0 : organisation.twitterUrl,
                        title: "Twitter",
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter/* default */.Z, {
                            className: "fill-current hover:text-gray-600 h-5"
                        })
                    }),
                    (organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: organisation === null || organisation === void 0 ? void 0 : organisation.linkedinUrl,
                        title: "LinkedIn",
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin/* default */.Z, {
                            className: "fill-current hover:text-gray-600 h-5"
                        })
                    }),
                    (organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: organisation === null || organisation === void 0 ? void 0 : organisation.githubUrl,
                        title: "GitHub",
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(github/* default */.Z, {
                            className: "fill-current hover:text-gray-600 h-5"
                        })
                    }),
                    (organisation === null || organisation === void 0 ? void 0 : organisation.instagramUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: organisation === null || organisation === void 0 ? void 0 : organisation.instagramUrl,
                        title: "Instagram",
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(instagram/* default */.Z, {
                            className: "fill-current hover:text-gray-600 h-5"
                        })
                    }),
                    (organisation === null || organisation === void 0 ? void 0 : organisation.youtubeUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: organisation === null || organisation === void 0 ? void 0 : organisation.youtubeUrl,
                        title: "YouTube",
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube/* default */.Z, {
                            className: "fill-current hover:text-gray-600 h-5"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@prisma/client/index-browser.js
var client_index_browser = __webpack_require__(70385);
// EXTERNAL MODULE: ./types/tags.ts
var types_tags = __webpack_require__(75474);
;// CONCATENATED MODULE: ./components/JobPost/blocks/EmploymentTypesBlock.tsx




const EmploymentTypesBlock = (param)=>{
    let { tags =[] , tagCN  } = param;
    const employmentTypeTags = tags === null || tags === void 0 ? void 0 : tags.filter((t)=>t.type === types_tags/* TagType.EMPLOYMENT_TYPE */.Q.EMPLOYMENT_TYPE);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: employmentTypeTags.map((param)=>/*#__PURE__*/ {
            let { id , label  } = param;
            return (0,jsx_runtime.jsx)("a", {
                href: "/search?tags=".concat(id),
                className: "hover:underline",
                rel: "nofollow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,classNames/* classNames */.A)(tagCN),
                    children: label || id
                })
            }, id);
        })
    });
};

;// CONCATENATED MODULE: ./components/JobPost/blocks/TagsBlock.tsx



const TagsBlock = (param)=>{
    let { tags =[] , cN , tagCN  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classNames/* classNames */.A)(cN),
        children: tags.map((param, index)=>/*#__PURE__*/ {
            let { id , label  } = param;
            return (0,jsx_runtime.jsx)("a", {
                href: "/search?tags=".concat(id),
                rel: "nofollow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,classNames/* classNames */.A)(tagCN, "hover:bg-gray-200"),
                    children: label || id
                })
            }, id || index);
        })
    });
};

// EXTERNAL MODULE: ./components/JobPost/blocks/OnsiteLocationsBlock.tsx
var OnsiteLocationsBlock = __webpack_require__(85563);
// EXTERNAL MODULE: ./components/JobPost/blocks/RemoteLocationsBlock.tsx + 4 modules
var RemoteLocationsBlock = __webpack_require__(11296);
;// CONCATENATED MODULE: ./components/JobPost/blocks/SummaryBlock.tsx










const SummaryBlock = (param)=>{
    let { jobPost  } = param;
    var //jobPost.remote?.type === JobPostRemoteType.GENERAL ||
    ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "space-y-6",
        children: [
            (jobPost.originType === index_browser.JobPostOriginType.SCRAPED || jobPost.originType === index_browser.JobPostOriginType.SCRAPED_CHROME_EXTENSION || jobPost.originType === index_browser.JobPostOriginType.POSTED && jobPost.hasHiringOrganisation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold",
                        children: "Company"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganisationBlock, {
                        organisation: jobPost.hiringOrganisation
                    })
                ]
            }),
            jobPost.hasSourcingOrganisation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold",
                        children: "Recruitment company"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganisationBlock, {
                        organisation: jobPost.sourcingOrganisation
                    })
                ]
            }),
            jobPost.locations.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold",
                        children: "Onsite Locations"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OnsiteLocationsBlock/* OnsiteLocationsBlock */.$, {
                        locations: jobPost.locations
                    })
                ]
            }),
            (((ref = jobPost.remote) === null || ref === void 0 ? void 0 : ref.type) === client_index_browser.JobPostRemoteType.WORLDWIDE || ((ref1 = jobPost.remote) === null || ref1 === void 0 ? void 0 : ref1.type) === client_index_browser.JobPostRemoteType.SELECTED_REGIONS) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold",
                        children: "Hires remotely in"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteLocationsBlock/* RemoteLocationsBlock */.D, {
                        remote: jobPost.remote
                    })
                ]
            }),
            ((ref3 = (ref2 = jobPost.tags) === null || ref2 === void 0 ? void 0 : ref2.filter((t)=>t.type === types_tags/* TagType.EMPLOYMENT_TYPE */.Q.EMPLOYMENT_TYPE)) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold",
                        children: "Employment type"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmploymentTypesBlock, {
                        tags: jobPost.tags,
                        tagCN: "block"
                    })
                ]
            }),
            ((ref4 = jobPost.extras) === null || ref4 === void 0 ? void 0 : ref4.providesVisaSponsorship) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold",
                        children: "Visa Sponsorship"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: ((ref5 = jobPost.extras) === null || ref5 === void 0 ? void 0 : ref5.providesVisaSponsorship) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/search?tags=visa-sponsorship",
                            className: "hover:underline",
                            rel: "nofollow",
                            children: "Available"
                        }) : "Not available"
                    })
                ]
            }),
            ((ref6 = jobPost.extras) === null || ref6 === void 0 ? void 0 : ref6.providesPaidRelocation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold",
                        children: "Paid relocation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: ((ref7 = jobPost.extras) === null || ref7 === void 0 ? void 0 : ref7.providesPaidRelocation) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/search?tags=paid-relocation",
                            className: "hover:underline",
                            rel: "nofollow",
                            children: "Available"
                        }) : "Not available"
                    })
                ]
            }),
            ((ref8 = jobPost.tags) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold",
                        children: "Tags"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsBlock, {
                        tags: jobPost.tags,
                        cN: "",
                        tagCN: "inline-block mr-1 mb-0.5 px-1.5 py-1 text-xxs font-semibold bg-gray-100 rounded-sm"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
// EXTERNAL MODULE: ./config/config.client.ts
var config_client = __webpack_require__(39223);
;// CONCATENATED MODULE: ./components/JsonLd/JobPostingJsonLd.tsx





const JobPostingJsonLd = (param)=>{
    let { jobPost  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    // Return early if no jobPost.
    if (!jobPost) return null;
    // EmploymentType from assigned tags.
    const employmentType = (ref = jobPost.tags) === null || ref === void 0 ? void 0 : ref.filter((t)=>t.type === types_tags/* TagType.EMPLOYMENT_TYPE */.Q.EMPLOYMENT_TYPE).map((t)=>t.id);
    // hiringOrganization !! This one is using american english, so it is spelled with a Z.
    const hiringOrganization = ((jobPost === null || jobPost === void 0 ? void 0 : (ref1 = jobPost.hiringOrganisation) === null || ref1 === void 0 ? void 0 : ref1.name) || (jobPost === null || jobPost === void 0 ? void 0 : (ref2 = jobPost.hiringOrganisation) === null || ref2 === void 0 ? void 0 : ref2.webUrl)) && {
        "@type": "Organization",
        name: (jobPost === null || jobPost === void 0 ? void 0 : (ref3 = jobPost.hiringOrganisation) === null || ref3 === void 0 ? void 0 : ref3.name) || (jobPost === null || jobPost === void 0 ? void 0 : (ref4 = jobPost.hiringOrganisation) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.webUrl) === null || ref5 === void 0 ? void 0 : ref5.replace("https://", ""))
    };
    // jobLocation
    const firstLocationFormattedAddress = (jobPost === null || jobPost === void 0 ? void 0 : (ref6 = jobPost.locations) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.formattedAddress) || (jobPost === null || jobPost === void 0 ? void 0 : (ref8 = jobPost.locations) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.address);
    const jobLocation = firstLocationFormattedAddress && {
        "@type": "Place",
        address: firstLocationFormattedAddress
    };
    // jobLocationType (TELECOMMUTE)
    const hasRemote = (jobPost === null || jobPost === void 0 ? void 0 : (ref10 = jobPost.remote) === null || ref10 === void 0 ? void 0 : ref10.type) === client_index_browser.JobPostRemoteType.WORLDWIDE || (jobPost === null || jobPost === void 0 ? void 0 : (ref11 = jobPost.remote) === null || ref11 === void 0 ? void 0 : ref11.type) === client_index_browser.JobPostRemoteType.SELECTED_REGIONS && (jobPost === null || jobPost === void 0 ? void 0 : (ref12 = jobPost.remote) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.regionsPopulated) === null || ref13 === void 0 ? void 0 : ref13.length) > 0;
    const jobLocationType = hasRemote ? "TELECOMMUTE" : undefined;
    // baseSalary
    const baseSalary = (jobPost === null || jobPost === void 0 ? void 0 : (ref14 = jobPost.compensation) === null || ref14 === void 0 ? void 0 : ref14.max) && {
        "@type": "MonetaryAmount",
        currency: jobPost === null || jobPost === void 0 ? void 0 : (ref15 = jobPost.compensation) === null || ref15 === void 0 ? void 0 : ref15.currency,
        value: {
            "@type": "QuantitativeValue",
            value: jobPost === null || jobPost === void 0 ? void 0 : (ref16 = jobPost.compensation) === null || ref16 === void 0 ? void 0 : ref16.max,
            unitText: jobPost === null || jobPost === void 0 ? void 0 : (ref17 = jobPost.compensation) === null || ref17 === void 0 ? void 0 : ref17.unit
        }
    };
    // Put it all together.
    const jsonLD = {
        "@context": "http://schema.org",
        "@type": "JobPosting",
        datePosted: jobPost === null || jobPost === void 0 ? void 0 : jobPost.createdAt,
        validThrough: (0,add/* default */.Z)(new Date(jobPost.createdAt), {
            days: config_client/* JOB_POST_PUBLISH_DURATION_IN_DAYS */.Rr
        }),
        title: jobPost === null || jobPost === void 0 ? void 0 : jobPost.title,
        description: jobPost === null || jobPost === void 0 ? void 0 : jobPost.description,
        ...employmentType ? {
            employmentType
        } : {},
        ...hiringOrganization ? {
            hiringOrganization
        } : {},
        ...jobLocation ? {
            jobLocation
        } : {},
        ...jobLocationType ? {
            jobLocationType
        } : {},
        ...baseSalary ? {
            baseSalary
        } : {}
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(jsonLD)
        }
    });
};

// EXTERNAL MODULE: ./components/JobPost/JobPostPreview.tsx + 2 modules
var JobPostPreview = __webpack_require__(87938);
// EXTERNAL MODULE: ./utils/db/Compensation/getCompensationAsString.ts + 1 modules
var getCompensationAsString = __webpack_require__(32246);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/BanknotesIcon.js
var BanknotesIcon = __webpack_require__(12435);
;// CONCATENATED MODULE: ./components/JobPost/JobPostDetailPage.tsx
















const JobPostDetail = (param)=>{
    let { jobPost , similarJobPosts , avoidAppleReaderMode , canonicalUrl  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    const appleReaderModeMenu = '<h3 class="mt-6 mb-6 text-xs font-black text-blue-600 sm:hidden"><a href="/">➔ All jobs</a></h3>\n  '.concat(((ref = jobPost.hiringOrganisation) === null || ref === void 0 ? void 0 : ref.name) && ((ref1 = jobPost.hiringOrganisation) === null || ref1 === void 0 ? void 0 : ref1.slug) ? '<h3 class="mb-6 text-xs font-black text-blue-600 sm:hidden"><a href="/company/'.concat((ref2 = jobPost.hiringOrganisation) === null || ref2 === void 0 ? void 0 : ref2.slug, '">➔ Jobs at ').concat((ref3 = jobPost.hiringOrganisation) === null || ref3 === void 0 ? void 0 : ref3.name, "</a></h3>") : "", '\n  <h3 class="mb-10 text-xs font-black text-blue-600 sm:hidden"><a href="').concat(jobPost.applyUrl, '" target="_blank">➔ Apply for this job</a></h3>');
    (0,react.useEffect)(()=>{
        // Google analytics: Record job post detail view.
        (0,googleAnalytics/* gtagEvent */.o)({
            name: "view_item",
            payload: {
                items: [
                    {
                        id: jobPost.id
                    }
                ]
            }
        });
        // Mixpanel: Record job post detail view.
        (0,mixpanel/* mixpanelEvent */.f)({
            name: AnalyticsEvent/* AnalyticsEvent.JOB_POST_DETAIL */.s.JOB_POST_DETAIL,
            payload: {
                id: jobPost.id
            }
        });
        // Internal analytics: Record job post detail view.
        fetch("/api/analytics/collect", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                event: AnalyticsEvent/* AnalyticsEvent.JOB_POST_DETAIL */.s.JOB_POST_DETAIL,
                ids: [
                    jobPost.id
                ]
            })
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "".concat(jobPost.description.slice(0, 130), "...")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "".concat(jobPost.title).concat(((ref4 = jobPost.hiringOrganisation) === null || ref4 === void 0 ? void 0 : ref4.name) ? " at ".concat((ref5 = jobPost.hiringOrganisation) === null || ref5 === void 0 ? void 0 : ref5.name) : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "".concat(jobPost.description.slice(0, 130), "...")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@jobsinjs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat("https://jobsinjs.com", "/api/job-posts/").concat(jobPost.id, "/og-image")
                    }),
                    canonicalUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:title",
                        content: "".concat(jobPost.title).concat(((ref6 = jobPost.hiringOrganisation) === null || ref6 === void 0 ? void 0 : ref6.name) ? " at ".concat((ref7 = jobPost.hiringOrganisation) === null || ref7 === void 0 ? void 0 : ref7.name) : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: "".concat(jobPost.description.slice(0, 130), "...")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:image",
                        content: "".concat("https://jobsinjs.com", "/api/job-posts/").concat(jobPost.id, "/og-image")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostingJsonLd, {
                jobPost: jobPost
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between py-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/company/".concat((ref8 = jobPost.hiringOrganisation) === null || ref8 === void 0 ? void 0 : ref8.slug),
                                        className: "shrink-0 w-16",
                                        children: ((ref9 = jobPost.hiringOrganisation) === null || ref9 === void 0 ? void 0 : ref9.favicon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "rounded",
                                            width: 48,
                                            height: 48,
                                            src: "".concat("https://xxshqbqasrbviwgjwzwp.supabase.co", "/storage/v1/object/public/public").concat(jobPost === null || jobPost === void 0 ? void 0 : (ref10 = jobPost.hiringOrganisation) === null || ref10 === void 0 ? void 0 : ref10.favicon),
                                            alt: "".concat((jobPost === null || jobPost === void 0 ? void 0 : (ref11 = jobPost.hiringOrganisation) === null || ref11 === void 0 ? void 0 : ref11.name) || "", " logo")
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center items-center w-10 h-10 rounded bg-gray-100 ",
                                            children: (ref12 = jobPost.hiringOrganisation) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.name) === null || ref13 === void 0 ? void 0 : ref13[0]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "shrink-1 text-2xl font-bold",
                                                children: jobPost.title
                                            }),
                                            (jobPost === null || jobPost === void 0 ? void 0 : (ref14 = jobPost.hiringOrganisation) === null || ref14 === void 0 ? void 0 : ref14.name) && ((ref15 = jobPost.hiringOrganisation) === null || ref15 === void 0 ? void 0 : ref15.slug) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/company/".concat((ref16 = jobPost.hiringOrganisation) === null || ref16 === void 0 ? void 0 : ref16.slug),
                                                    children: jobPost.hiringOrganisation.name
                                                })
                                            }),
                                            (0,getCompensationAsString/* getCompensationAsString */.D)(jobPost.compensation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "my-2 text-md font-boldX",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BanknotesIcon/* default */.Z, {
                                                        className: "inline w-4 h-4 mr-1"
                                                    }),
                                                    (0,getCompensationAsString/* getCompensationAsString */.D)(jobPost.compensation)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-2 text-xxs text-gray-400 uppercase",
                                                children: (0,timeSinceFormatter/* timeSinceFormatter */.H)(new Date(jobPost.createdAt), {
                                                    addSuffix: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden pl-4 sm:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Apply, {
                                id: jobPost.id,
                                applyUrl: jobPost.applyUrl,
                                cN: "inline-block mb-4 px-4 sm:px-10"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-12 gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,classNames/* classNames */.A)("container sm:col-span-8", avoidAppleReaderMode ? "col-span-9" : "col-span-12"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-4 border-t",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "job-post-description text-base",
                                    dangerouslySetInnerHTML: {
                                        __html: "".concat(appleReaderModeMenu, " ").concat(jobPost.description) || ""
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "my-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Apply, {
                                    id: jobPost.id,
                                    applyUrl: jobPost.applyUrl,
                                    cN: "inline-block mb-4 px-4"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-12 sm:col-span-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-4 pb-6 border rounded-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryBlock, {
                                jobPost: jobPost
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: (similarJobPosts === null || similarJobPosts === void 0 ? void 0 : similarJobPosts.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-4xl mt-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mb-4 text-xl font-bold",
                            children: "More jobs currently hiring JavaScript developers"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: similarJobPosts === null || similarJobPosts === void 0 ? void 0 : similarJobPosts.map((similarJobPost)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostPreview/* JobPostPreview */.n, {
                                    jobPost: similarJobPost,
                                    cN: "pt-3 pb-3 text-xs border-t"
                                }, similarJobPost.id))
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 39223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DQ": function() { return /* binding */ ORGANISATIONS_AUTOCOMPLETE_LIMIT; },
/* harmony export */   "Rr": function() { return /* binding */ JOB_POST_PUBLISH_DURATION_IN_DAYS; },
/* harmony export */   "Wt": function() { return /* binding */ QUALITY_SCORE_THRESHOLD; }
/* harmony export */ });
/* unused harmony exports ES_DEFAULT_DISTANCE_IN_KM, TAG_SCORE_THRESHOLD */
// CLIENT CONFIG (public)
const JOB_POST_PUBLISH_DURATION_IN_DAYS = 28;
const ES_DEFAULT_DISTANCE_IN_KM = 100;
const TAG_SCORE_THRESHOLD = 30;
const QUALITY_SCORE_THRESHOLD = 30;
const ORGANISATIONS_AUTOCOMPLETE_LIMIT = 10;


/***/ }),

/***/ 75474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ TagType; }
/* harmony export */ });
/* unused harmony export TagClassifierEngine */
var TagType;
(function(TagType) {
    TagType["JOB_POST_META"] = "JOB_POST_META";
    TagType["JOB"] = "JOB";
    TagType["COMPENSATION_BENEFIT"] = "COMPENSATION_BENEFIT";
    TagType["ORGANISATION"] = "ORGANISATION";
    TagType["ROLE"] = "ROLE";
    TagType["EXPERIENCE_LEVEL"] = "EXPERIENCE_LEVEL";
    TagType["PROGRAMMING_LANGUAGE"] = "PROGRAMMING_LANGUAGE";
    TagType["TECHNOLOGY"] = "TECHNOLOGY";
    TagType["MARKET"] = "MARKET";
    TagType["EMPLOYMENT_TYPE"] = "EMPLOYMENT_TYPE";
})(TagType || (TagType = {}));
var TagClassifierEngine;
(function(TagClassifierEngine) {
    TagClassifierEngine["KEYWORD_MATCH"] = "KEYWORD_MATCH";
    TagClassifierEngine["ROLE_MATCH"] = "ROLE_MATCH";
    TagClassifierEngine["IS_4_DAY_WEEK"] = "IS_4_DAY_WEEK";
    TagClassifierEngine["IS_OUTSIDE_IR35"] = "IS_OUTSIDE_IR35";
    TagClassifierEngine["IS_VISA_SPONSORED"] = "IS_VISA_SPONSORED";
    TagClassifierEngine["IS_RELOCATION_PAID"] = "IS_RELOCATION_PAID";
    TagClassifierEngine["IS_FULLY_REMOTE"] = "IS_FULLY_REMOTE";
})(TagClassifierEngine || (TagClassifierEngine = {}));


/***/ })

}]);